.crewEquipmentGrid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 2rem;
    align-items: start;
}

@media (max-width: 40em) {
    .crewEquipmentGrid {
        grid-template-columns: 1fr;
    }
}

.crewColumn,
.equipmentColumn {
    min-width: 0;
}

.requirementSection {
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-sm);
    min-width: 0;
}

.assignedCard {
    background: var(--mantine-color-white);
}

.weekStrip {
    overflow-x: auto;
}

.compactWeekStrip {
    padding-top: 2px;
}

.pickerColumnHeader {
    position: sticky;
    top: 0;
    z-index: 1;
    /* Match Combobox.Option inset so labels sit over Name / sparkline columns */
    padding: 0.35rem 0.75rem 0.3rem 0.75rem;
    margin: 0 0 0.15rem;
    background: var(--mantine-color-body);
    border-bottom: 1px solid var(--mantine-color-gray-2);
}

.pickerColumnHeaderLabel {
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--mantine-color-dimmed);
    line-height: 1.2;
}

.pickerAvailabilityColumn {
    flex-shrink: 0;
    width: 7.75rem;
    display: flex;
    justify-content: flex-end;
}

.compactWeekLegend {
    row-gap: 0.15rem;
}

.compactWeekDays {
    overflow-x: visible;
    padding-bottom: 0;
    flex-shrink: 0;
}

.compactWeekDay {
    flex: 0 0 auto;
}

.compactWeekDot {
    width: 1.125rem;
    height: 1.125rem;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.5rem;
    font-weight: 700;
    line-height: 1;
    text-transform: uppercase;
    letter-spacing: 0;
    background: var(--mantine-color-gray-2);
    color: var(--mantine-color-gray-7);
    box-sizing: border-box;
    border: none;
    padding: 0;
    font-family: inherit;
    cursor: default;
}

.compactWeekDot[data-status='unassigned'] {
    background: color-mix(in srgb, var(--mt-availability-free) 42%, white);
    color: var(--mantine-color-green-9);
}

.compactWeekDot[data-status='bounded'],
.compactWeekDot[data-status='open_ended'] {
    background: color-mix(in srgb, var(--mt-availability-busy) 55%, white);
    color: var(--mantine-color-gray-8);
    cursor: pointer;
}

.compactWeekDot[data-reference='true'] {
    box-shadow: inset 0 0 0 1.5px var(--mantine-color-gray-7);
}

/* Only days that overlap the job being assigned — echo Conflict badge */
.compactWeekDot[data-conflict-day='true'] {
    background: color-mix(in srgb, var(--mt-signal-attention) 28%, white);
    color: var(--mt-signal-attention-8);
}

.compactWeekDot[data-reference='true'][data-conflict-day='true'] {
    box-shadow: inset 0 0 0 1.5px var(--mt-signal-attention-8);
}

/* Legacy bar styles kept for any non-sparkline compact use */
.compactWeekSwatch,
.compactWeekBar {
    border-radius: 3px;
    background: var(--mantine-color-gray-3);
}

.compactWeekSwatch {
    width: 0.5rem;
    height: 0.5rem;
    flex-shrink: 0;
}

.compactWeekSwatch[data-status='unassigned'],
.compactWeekBar[data-status='unassigned'] {
    background: color-mix(in srgb, var(--mt-availability-free) 55%, white);
}

.compactWeekSwatch[data-status='bounded'],
.compactWeekBar[data-status='bounded'] {
    background: color-mix(in srgb, var(--mt-availability-busy) 70%, white);
}

.compactWeekSwatch[data-status='open_ended'],
.compactWeekBar[data-status='open_ended'] {
    background: color-mix(in srgb, var(--mt-availability-open) 70%, white);
}

.compactWeekBar {
    width: 100%;
    height: 0.15rem;
    border-radius: 1px;
}

.compactWeekDayLabel {
    font-size: 0.5625rem;
    line-height: 1;
    font-weight: 500;
    color: var(--mantine-color-dimmed);
    text-transform: uppercase;
}

.readyPanel {
    padding: 0.75rem;
    border-radius: var(--mantine-radius-md);
    background: color-mix(in srgb, var(--mt-signal-positive-0) 55%, white);
    border: 1px solid var(--mt-signal-positive-3);
}

.sparklineTipDropdown {
    padding: 0 !important;
    border: 1px solid var(--mantine-color-gray-2);
    border-radius: 10px;
    overflow: hidden;
}

.sparklineTip {
    padding: 0.7rem 0.8rem 0.75rem;
    text-align: left;
}

.sparklineTipMeta {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 0.35rem 0.45rem;
}

.sparklineTipHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
}

.sparklineTipDate {
    margin: 0;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: var(--mantine-color-dimmed);
}

.sparklineTipBadge,
.sparklineTipMutedBadge {
    flex-shrink: 0;
    font-size: 0.625rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    line-height: 1;
    padding: 0.28rem 0.4rem;
    border-radius: 999px;
}

.sparklineTipBadge {
    color: var(--mt-signal-attention-8);
    background: color-mix(in srgb, var(--mt-signal-attention) 16%, white);
}

.sparklineTipMutedBadge {
    color: var(--mantine-color-gray-7);
    background: var(--mantine-color-gray-1);
}

.sparklineTipList {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 0.65rem;
}

.sparklineTipItem {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
}

.sparklineTipJob {
    margin: 0;
    font-size: 0.875rem;
    font-weight: 650;
    line-height: 1.25;
    color: var(--mantine-color-dark-7);
}

.sparklineTipEmpty {
    margin: 0;
    font-size: 0.8125rem;
    color: var(--mantine-color-dimmed);
}

.sparklineTipAction {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    font: inherit;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.2;
    cursor: pointer;
    text-decoration: none;
    color: var(--mantine-color-blue-6);
}

.sparklineTipAction:hover {
    color: var(--mantine-color-blue-8);
}
